import { render, staticRenderFns } from "./photoGalleryCommentModal.vue?vue&type=template&id=05297cf8&"
import script from "./photoGalleryCommentModal.vue?vue&type=script&lang=js&"
export * from "./photoGalleryCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports